import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Typography } from '@mui/material';
import { api_urls } from '../../utils/api-urls';
import Dashboard from './Dashboard.jsx';

// Map permission names to their first valid route path
const PERMISSION_ROUTE_MAP = {
    'Dashboard': '/',
    'Astrologer': '/astrologer',
    'Services History': '/service-history/recharge',
    'Astro Mall': '/astro-mall/category',
    'Astro Puja': '/astro-puja/puja',
    'User': '/user',
    'New Users': '/new-users',
    'Notifications': '/notifications',
    'Utilities': '/utilities',
    'Sub Admin': '/sub-admin',
    'Banner': '/banner',
    'Category': '/category',
    'Sub Category': '/sub-category',
    'Yatra': '/yatra/packages',
    'Sanchar': '/sanchar/podcast',
    'Religious': '/religious/daily-darshan',
    'Transaction': '/transaction',
    'Operator Images': '/operator-images',
    'Flight Images': '/flight-images',
    'Static Pages': '/static-page/terms',
    'TBO Bookings': '/tbo-bookings/flights',
    'Milan Sathi': '/milan-sathi/dashboard',
    'Reports': '/reports',
    'App Errors': '/app-errors',
    'Post Banao': '/post-banao',
    'Rojgar': '/rojgar/dashboard',
    'Marketplace': '/marketplace/dashboard',
    'Sanatani Manch': '/sanatani-manch/dashboard',
    'Roles & Logs': '/roles',
    'Issue Control': '/issues',
    'Home Sections': '/home-sections'
};

const DashboardGuard = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [showDashboard, setShowDashboard] = useState(false);

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        try {
            const userType = localStorage.getItem('userType');
            const userId = localStorage.getItem('userId');

            // Admin users always see dashboard
            if (userType === 'admin') {
                setShowDashboard(true);
                setLoading(false);
                return;
            }

            // Sub-admin: check permissions
            if (userId) {
                const { data } = await axios.post(api_urls + 'api/admin/getPermissions', { id: userId });
                const permissions = data?.results?.permission || data?.results?.permissions || [];

                // If sub-admin has Dashboard permission, show dashboard
                if (permissions.includes('Dashboard')) {
                    setShowDashboard(true);
                    setLoading(false);
                    return;
                }

                // Find first permitted route
                for (const perm of permissions) {
                    if (PERMISSION_ROUTE_MAP[perm]) {
                        navigate(PERMISSION_ROUTE_MAP[perm], { replace: true });
                        return;
                    }
                }

                // No permissions at all - show message
                setShowDashboard(false);
                setLoading(false);
            } else {
                setShowDashboard(true);
                setLoading(false);
            }
        } catch (error) {
            console.log('DashboardGuard error:', error);
            setShowDashboard(true);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', flexDirection: 'column', gap: 2 }}>
                <CircularProgress />
                <Typography variant="body2" color="text.secondary">Loading...</Typography>
            </Box>
        );
    }

    if (!showDashboard) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>Access Restricted</Typography>
                <Typography variant="body1" color="text.secondary">You do not have permission to access this page. Contact your admin.</Typography>
            </Box>
        );
    }

    return <Dashboard />;
};

export default DashboardGuard;
